const CHARACTERS = {
  fox: { emoji: null, label: "Zorro", path: "M12 3l3 4h4l-2 4 2 4h-4l-3 4-3-4H5l2-4-2-4h4z" },
  owl: { label: "Buho", path: "M12 2a7 7 0 017 7v5a7 7 0 01-14 0V9a7 7 0 017-7z" },
  cat: { label: "Gato", path: "M4 4l4 3h8l4-3v9a8 8 0 01-16 0z" },
  rocket: { label: "Cohete", path: "M12 2c4 3 6 7 6 11l-6 9-6-9c0-4 2-8 6-11z" },
};

const COLORS = {
  blue: "bg-blue-100 text-blue-700",
  emerald: "bg-emerald-100 text-emerald-700",
  amber: "bg-amber-100 text-amber-700",
  violet: "bg-violet-100 text-violet-700",
  rose: "bg-rose-100 text-rose-700",
};

const SIZES = { sm: "h-10 w-10", md: "h-16 w-16", lg: "h-24 w-24" };
const ACCESSORIES = { star: "★", glasses: "⌐◉-◉", crown: "♛", flame: "◆" };

export function Avatar({ config, name = "", size = "md", testId = "student-avatar" }) {
  const character = CHARACTERS[config?.character] || CHARACTERS.fox;
  const color = COLORS[config?.color] || COLORS.blue;
  return (
    <span
      className={`relative grid shrink-0 place-items-center rounded-2xl ${color} ${SIZES[size]}`}
      title={`${name} · ${character.label}`}
      data-testid={testId}
    >
      <svg viewBox="0 0 24 24" className="h-1/2 w-1/2" fill="currentColor" aria-hidden="true">
        <path d={character.path} />
      </svg>
      {ACCESSORIES[config?.accessory] && (
        <span className="absolute -right-1 -top-2 rounded-full bg-white px-1 text-sm font-black text-amber-500 shadow-sm" aria-hidden="true">
          {ACCESSORIES[config.accessory]}
        </span>
      )}
    </span>
  );
}

export const AVATAR_CHARACTERS = Object.keys(CHARACTERS);
export const AVATAR_COLORS = Object.keys(COLORS);
